import { FadeUp, SectionLabel } from "../components/Motion";
import { careers } from "../data/projects";
import { buildWhatsappUrl, EMAIL } from "../lib/whatsapp";
import { Mail, MessageCircle, ArrowRight } from "lucide-react";

export default function Careers({ onEnquire }) {
  const waUrl = buildWhatsappUrl("Hello, I'd like to apply for a role at Sanggavai Constructions.");
  return (
    <div data-testid="careers-page" className="bg-[#FAFAFA]">
      <section className="pt-36 md:pt-44 pb-16 md:pb-20">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl text-center">
          <FadeUp>
            <SectionLabel>Careers</SectionLabel>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-6 tracking-tight text-[#1A1A1A]">
              Build with <span className="italic brand-gradient-text">us.</span>
            </h1>
            <p className="mt-8 text-[#555] text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
              Join a team that believes in craft, care and quality. We hire people who care as much about the detail as the deadline.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl">
          <FadeUp>
            <h2 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] mb-8 tracking-tight">Open positions</h2>
          </FadeUp>
          <div className="divide-y divide-black/10 border-y border-black/10">
            {careers.map((c, i) => (
              <FadeUp key={c.role} delay={i * 0.05}>
                <div data-testid={`job-${i}`} className="flex flex-col md:flex-row md:items-center md:justify-between py-8 gap-4">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-[#1A1A1A]">{c.role}</h3>
                    <p className="text-[#555] mt-1">{c.type} · {c.location}</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => onEnquire({ projectName: `Application: ${c.role}` })}
                    data-testid={`apply-btn-${i}`}
                    className="inline-flex items-center gap-2 self-start md:self-auto border-2 border-[#7A2E5D] text-[#7A2E5D] rounded-full px-6 py-2.5 font-medium hover:bg-[#7A2E5D] hover:text-white transition-all"
                  >
                    Apply <ArrowRight className="h-4 w-4" />
                  </button>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp className="mt-16">
            <div className="bg-white rounded-2xl border border-black/5 p-10 md:p-12 text-center">
              <h3 className="font-serif text-3xl text-[#1A1A1A]">Don't see your role?</h3>
              <p className="text-[#555] mt-3 text-lg">Send us your resume — we're always open to great talent.</p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href={`mailto:${EMAIL}?subject=Career%20Application`}
                  data-testid="careers-email-btn"
                  className="inline-flex items-center gap-2 border-2 border-[#7A2E5D] text-[#7A2E5D] rounded-full px-6 py-3 font-medium hover:bg-[#7A2E5D] hover:text-white transition-all"
                >
                  <Mail className="h-4 w-4" /> Email CV
                </a>
                <a
                  href={waUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="careers-whatsapp-btn"
                  className="inline-flex items-center gap-2 brand-gradient text-white rounded-full px-6 py-3 font-medium hover:-translate-y-0.5 hover:shadow-lg transition-all"
                >
                  <MessageCircle className="h-4 w-4" /> WhatsApp
                </a>
              </div>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
